import { Instant } from "@js-joda/core";
import BloodGlucoseThresholds from "./BloodGlucoseThresholds";
import BloodPressureThresholds from "./BloodPressureThresholds";
import { Caregiver, CaregiverApiDto, toCaregiver, toCaregiverApiDto } from "./Caregiver";

export type DiabetesProtocol = {
  name: string;
  type: "diabetes";
  thresholds: BloodGlucoseThresholds;
};

export type HypertensionProtocol = {
  name: string;
  type: "hypertension";
  thresholds: BloodPressureThresholds;
};

export type PersonalizedDiabetesProtocol = DiabetesProtocol & {
  lastUpdatedAt?: Instant;
  lastUpdatedBy?: Caregiver;
};

export type PersonalizedHypertensionProtocol = HypertensionProtocol & {
  lastUpdatedAt?: Instant;
  lastUpdatedBy?: Caregiver;
};

export type PersonalizedDiabetesProtocolApiDto = DiabetesProtocol & {
  lastUpdatedAt?: string;
  lastUpdatedBy?: CaregiverApiDto;
};

export type PersonalizedHypertensionProtocolApiDto = HypertensionProtocol & {
  lastUpdatedAt?: string;
  lastUpdatedBy?: CaregiverApiDto;
};

export const toPersonalizedDiabetesProtocol = (
  dto: PersonalizedDiabetesProtocolApiDto
): PersonalizedDiabetesProtocol => ({
  ...dto,
  ...(dto.lastUpdatedAt && dto.lastUpdatedBy
    ? {
        lastUpdatedAt: Instant.parse(dto.lastUpdatedAt),
        lastUpdatedBy: toCaregiver(dto.lastUpdatedBy),
      }
    : {
        lastUpdatedAt: undefined,
        lastUpdatedBy: undefined,
      }),
});

export const toPersonalizedHypertensionProtocol = (
  dto: PersonalizedHypertensionProtocolApiDto
): PersonalizedHypertensionProtocol => ({
  ...dto,
  ...(dto.lastUpdatedAt && dto.lastUpdatedBy
    ? {
        lastUpdatedAt: Instant.parse(dto.lastUpdatedAt),
        lastUpdatedBy: toCaregiver(dto.lastUpdatedBy),
      }
    : {
        lastUpdatedAt: undefined,
        lastUpdatedBy: undefined,
      }),
});

export const toPersonalizedDiabetesProtocolApiDto = (
  protocol: PersonalizedDiabetesProtocol
): PersonalizedDiabetesProtocolApiDto => ({
  ...protocol,
  lastUpdatedAt: protocol.lastUpdatedAt?.toString(),
  lastUpdatedBy: protocol.lastUpdatedBy ? toCaregiverApiDto(protocol.lastUpdatedBy) : undefined,
});

export const toPersonalizedHypertensionProtocolApiDto = (
  protocol: PersonalizedHypertensionProtocol
): PersonalizedHypertensionProtocolApiDto => ({
  ...protocol,
  lastUpdatedAt: protocol.lastUpdatedAt?.toString(),
  lastUpdatedBy: protocol.lastUpdatedBy ? toCaregiverApiDto(protocol.lastUpdatedBy) : undefined,
});
